const STORAGE_KEY = 'preSigninLocation';
const hasWindow = typeof window !== 'undefined';

const normalizeLocation = (location) => {
    if (typeof location === 'string') {
        const trimmed = location.trim();
        if (!trimmed) {
            return {};
        }
        try {
            if (/^https?:\/\//i.test(trimmed)) {
                const url = new URL(trimmed);
                return { pathname: url.pathname, search: url.search, hash: url.hash, href: trimmed };
            }
        } catch (e) {
            // fall through to pathname-only handling
        }
        return { pathname: trimmed };
    }
    return location || (hasWindow ? window.location : {});
};

const buildFullPath = (location) => {
    const source = normalizeLocation(location);
    const rawPath = `${source?.pathname || ''}${source?.search || ''}${source?.hash || ''}`;
    return (rawPath || source?.path || source?.href || '').trim();
};

const isSigninOrLoginPath = (location) => {
    const path = (buildFullPath(location) || '').toLowerCase();
    const authPattern = /(^|[#/])(?:signin|login)(?=$|[/?#])/;
    return !!path && authPattern.test(path);
};

const buildPath = (location) => {
    const source = normalizeLocation(location);
    const path = buildFullPath(source);
    const isHashRoot = path === '/#/' || path === '/#';
    const isHashPath = path.startsWith('/#/');
    if (!path || path === '/' || isHashRoot || isHashPath || isSigninOrLoginPath(source)) {
        return null;
    }
    return path;
};

export const savePreSigninLocation = (location) => {
    if (!hasWindow || !window.localStorage) {
        return;
    }
    const path = buildPath(location);
    if (!path) {
        return;
    }
    try {
        window.localStorage.setItem(STORAGE_KEY, path);
    } catch (e) {
        return '/dashboard'
    }
};

export const consumePreSigninLocation = () => {
    if (!hasWindow || !window.localStorage) {
        return null;
    }
    try {
        const path = window.localStorage.getItem(STORAGE_KEY);
        if (path && path !== '/' && !isSigninOrLoginPath(path)) {
            window.localStorage.removeItem(STORAGE_KEY);
            return path;
        }
    } catch (e) {
        return '/dashboard'
    }
    return null;
};
